<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/finishedgoodsoutbound/add')">新增</el-button>
        <el-button type="primary" v-if="hasExport" @click="onExport">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="产品名称" prop="productName">
          <el-input clearable v-model.trim="searchForm.productName" placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item label="生产单号" prop="recordNumber">
          <el-input clearable v-model.trim="searchForm.recordNumber" placeholder="请输入生产单号" />
        </el-form-item>
        <el-form-item label="开始日期" prop="startTime">
          <el-date-picker v-model="searchForm.startTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择开始日期" />
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime">
          <el-date-picker v-model="searchForm.endTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="180" label="出库时间" prop="outboundTime">
          <template v-slot="{ row }">
            {{ formatDate(row.outboundTime, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="产品名称" prop="productName"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="产品规格" prop="productSpecName"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="生产单号" prop="recordNumber"></el-table-column>
        <el-table-column min-width="140" label="生产日期" prop="productionDate">
          <template v-slot="{ row }">
            {{ formatDate(row.productionDate) }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="出库数量" prop="outboundQuantity"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="发货人" prop="shipperUserName"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="领货人" prop="receiverUserName"></el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/finishedgoodsoutbound/detail?outboundId=' + row.outboundId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/finishedgoodsoutbound/edit?outboundId=' + row.outboundId)">编辑</el-button>
            <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.outboundId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import keepAlive from '@/mixins/keepAlive'
import { exportFiles } from '@/utils/globalMethods'

export default {
  name: 'FinishedGoodsOutbound',
  mixins: [keepAlive],
  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        productName: '',
        recordNumber: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadData() {
      const { startTime, endTime } = this.searchForm
      if (startTime && endTime && startTime > endTime) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }
      this.loading = true
      return this.$axios.get(this.$apis.prodManage.selectScFinishedGoodsOutboundByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm,
        startTime: startTime ? startTime + ' 00:00:00' : '',
        endTime: endTime ? endTime + ' 23:59:59' : ''
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).catch(() => {
        // 请求错误由全局拦截器提示。
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      return this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      return this.onSearch()
    },
    onExport() {
      const { startTime, endTime } = this.searchForm
      if (startTime && endTime && startTime > endTime) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }
      // 导出与列表使用同一时间边界，确保结束日期当天的数据不会被遗漏。
      exportFiles(this.$apis.prodManage.exportFinishedGoodsOutbound, {
        ...this.searchForm,
        startTime: startTime ? startTime + ' 00:00:00' : '',
        endTime: endTime ? endTime + ' 23:59:59' : ''
      })
    },
    deleteRow(outboundId) {
      return this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$axios.post(this.$apis.prodManage.deleteScFinishedGoodsOutbound, {
          outboundId
        })
      }).then(() => {
        if (this.tableData.length === 1 && this.page > 1) {
          this.page -= 1
        }
        return this.loadData()
      }).catch(() => {
        // 取消删除无需处理，请求错误由全局拦截器提示。
      })
    }
  }
}
</script>

<style scoped lang="scss">
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
